import React from 'react';

import SmartLink from 'Shared/components/SmartLink';

import googleDocsLogo from './googleDocsLogo.png';
import GoogleSmartMenu from '../SmartMenu/GoogleSmartMenu';
import { SmartLinkLogo, SmartLinkContainer } from '../components';

type Props = {
  children: React.ReactNode;
};

const GoogleDocsLink = ({ children, ...restProps }: Props) => (
  <SmartLinkContainer contentEditable={false}>
    <GoogleSmartMenu type="document" logoName={googleDocsLogo} {...restProps}>
      <SmartLink {...restProps}>
        <SmartLinkLogo src={googleDocsLogo} />
        {children}
      </SmartLink>
    </GoogleSmartMenu>
  </SmartLinkContainer>
);

export default GoogleDocsLink;
